export default __webpack_public_path__ + "static/media/heanet-default-b.0cb6ed81.jpg";